import { render, staticRenderFns } from "./Faculties.vue?vue&type=template&id=03fceba6&scoped=true&lang=true&"
import script from "./Faculties.vue?vue&type=script&lang=js&"
export * from "./Faculties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fceba6",
  null
  
)

export default component.exports